import { Component } from '@angular/core';

@Component({
  selector: 'taly-with-taly',
  templateUrl: './with-taly.component.html',
  styleUrls: ['./with-taly.component.scss'],
  standalone: false,
})
export class WithTalyComponent {}
